// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// JS
import './assets/js/fontawesome-all.js';
// Css
import './assets/css/web-ui.css';
import Bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Vue from 'vue';
import App from './App';
import router from './router';
import VueSession from 'vue-session';
import VueResource from 'vue-resource';
import moment from 'moment';
import 'moment/locale/th';
import VueMoment from 'vue-moment';
import VueLazyload from 'vue-lazyload';
import VTooltip from 'v-tooltip';
import 'element-ui/lib/theme-chalk/index.css';
import UIkit from 'uikit';
import 'uikit/dist/css/uikit-core.min.css';
import 'uikit/dist/js/uikit-core.min.js';
// import io from 'socket.io-client';
import store from './store/';
import { Loading, Alert, Dialog, Message } from 'element-ui';
import Icons from 'uikit/dist/js/uikit-icons';

Vue.config.productionTip = false;
UIkit.use(Icons);
Vue.use(Bootstrap);
Vue.use(VueSession);
Vue.use(VueResource);
Vue.use(VTooltip);
Vue.use(import('@websanova/vue-upload'));
Vue.use(VueMoment, { moment });
Vue.use(Loading.directive);
Vue.use(Alert);
Vue.use(Dialog);
Vue.prototype.$message = Message;
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://mushbot-static.softsq.com/mushroom_logo.jpg',
  attempt: 1,
  // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
  listenEvents: ['scroll'],
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1,
  },
});
Vue.directive('tooltip', VTooltip.VTooltip);
Vue.directive('close-popover', VTooltip.VClosePopover);
Vue.component('v-popover', VTooltip.VPopover);

// Admin-only console hook: enable customer-message editing UI.
// Usage in browser console:
//   window.enableEdit('mushadmin')   → show edit buttons on customer messages
//   window.disableEdit()             → hide them
window.enableEdit = function(token) {
  const ok = store.dispatch('chat/enableEditMessage', token);
  console.log(ok ? '[enableEdit] enabled' : '[enableEdit] invalid token');
  return ok;
};
window.disableEdit = function() {
  store.dispatch('chat/disableEditMessage');
  console.log('[enableEdit] disabled');
};
store.dispatch('chat/restoreEditMessageFlag');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {},
});



// WEBPACK FOOTER //
// ./src/main.js